import { render, staticRenderFns } from "./ExpertOpinion.vue?vue&type=template&id=e836e0a6&scoped=true&"
import script from "./ExpertOpinion.vue?vue&type=script&lang=js&"
export * from "./ExpertOpinion.vue?vue&type=script&lang=js&"
import style0 from "./ExpertOpinion.vue?vue&type=style&index=0&id=e836e0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e836e0a6",
  null
  
)

export default component.exports